import { NgModule } from '@angular/core';
import { MediaLoadDirective } from './media-load.directive';
import { ScrollStateDirective } from './scroll-state.directive';

@NgModule({
  declarations: [
    MediaLoadDirective,
    ScrollStateDirective
  ],
  exports: [
    MediaLoadDirective,
    ScrollStateDirective
  ],
})
export class ResourceDirectivesModule {}
